import React from "react";
import { Play } from "lucide-react";

const JourneyVideoBanner = () => {
  return (
    <div className="w-full bg-[#fdfaf5] py-12 md:py-20">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 relative">
        <div className="relative w-full aspect-video md:aspect-[21/9] overflow-hidden rounded-md shadow-2xl group cursor-pointer">
          
          {/* Thumbnail Image */}
          <img 
            src="https://images.unsplash.com/photo-1573408301145-b98c4af01158?auto=format&fit=crop&q=80&w=1600" 
            alt="Our Journey" 
            className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-105"
          />
          
          {/* Overlay Gradients */}
          <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-black/20"></div>

          {/* Center Play Button */}
          <div className="absolute inset-0 flex items-center justify-center">
             <div className="w-16 h-16 md:w-20 md:h-20 bg-white/20 backdrop-blur-sm rounded-full flex items-center justify-center border border-white/40 group-hover:bg-[#D4AF37]/80 transition-all duration-300">
                <Play className="w-6 h-6 md:w-8 md:h-8 text-white ml-2" fill="currentColor" />
             </div>
          </div>

          {/* Bottom Text Content */}
          <div className="absolute bottom-0 left-0 w-full p-6 md:p-10">
            <h3 className="text-2xl md:text-4xl font-serif text-white mb-2">Our Journey</h3>
            <p className="text-gray-300 text-sm md:text-base max-w-2xl leading-relaxed">
              A glimpse into the timeless artistry behind HIRAPANNA. From a single store to a global presence, witness our legacy of purity and trust.
            </p>
          </div>

        </div>
      </div>
    </div>
  );
};

export default JourneyVideoBanner;
